/*
  Shared behaviour for the Carni overlays (share, back-in-stock notify, favourites
  variant picker, clear-all confirm). Each of these used to hand-roll its own open
  and close, which is where the accessibility gaps came from: no focus trap, no
  focus restore, no scrollbar compensation, and an Escape key that closed both the
  overlay and whatever theme drawer was underneath it.

  Exposed as window.CarniModal so the individual snippets stay small.
*/
(function () {
  if (window.CarniModal) return;

  var stack = [];

  // Width of the classic scrollbar, so locking the page does not shift it sideways.
  function scrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  // Inside a theme drawer or quick view the host already owns the scroll lock.
  // Taking a second one leaks it when the host tears down our markup on close.
  function hostHoldsLock(el) {
    return !!(el && el.closest && el.closest('quick-view-modal, modal-component, drawer-component, .drawer'));
  }

  function lock() {
    var doc = document.documentElement;
    if (doc.style.overflow === 'hidden') return;
    var w = scrollbarWidth();
    doc.setAttribute('data-carni-prev-pr', doc.style.paddingRight || '');
    doc.style.overflow = 'hidden';
    if (w > 0) doc.style.paddingRight = w + 'px';
  }

  function unlock() {
    var doc = document.documentElement;
    doc.style.overflow = '';
    doc.style.paddingRight = doc.getAttribute('data-carni-prev-pr') || '';
    doc.removeAttribute('data-carni-prev-pr');
  }

  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ),
      function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; }
    );
  }

  function onKeydown(e) {
    var top = stack[stack.length - 1];
    if (!top) return;

    if (e.key === 'Escape') {
      // The theme closes its own drawers on keyup. Closing here on keydown and
      // then letting the keyup through means one Escape closes our overlay AND
      // the quick view beneath it, so swallow the matching keyup once.
      e.preventDefault();
      document.addEventListener('keyup', function swallow(ev) {
        if (ev.key === 'Escape') ev.stopImmediatePropagation();
        document.removeEventListener('keyup', swallow, true);
      }, true);
      CarniModal.close(top.el);
      return;
    }

    if (e.key !== 'Tab') return;
    var items = focusables(top.el);
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var CarniModal = {
    /*
      el          the overlay element (the backdrop that wraps the panel)
      opts.focus  element to focus once open; defaults to the first focusable
      opts.onClose optional callback
    */
    open: function (el, opts) {
      if (!el || stack.some(function (e) { return e.el === el; })) return;
      opts = opts || {};

      // A pointer or programmatic open often leaves activeElement on <body>, and
      // restoring focus there would dump the user at the top of the document. Fall
      // back to the control that opened us.
      var active = document.activeElement;
      if (!active || active === document.body || active === document.documentElement) active = opts.trigger || null;

      var entry = {
        el: el,
        returnTo: active,
        tookLock: !hostHoldsLock(opts.trigger || el),
        onClose: opts.onClose || null
      };
      stack.push(entry);

      el.hidden = false;
      if (entry.tookLock) lock();

      if (stack.length === 1) document.addEventListener('keydown', onKeydown, true);

      var target = opts.focus || focusables(el)[0];
      if (target) setTimeout(function () { try { target.focus(); } catch (_) {} }, 50);
    },

    close: function (el) {
      var ix = -1;
      for (var i = stack.length - 1; i >= 0; i--) { if (stack[i].el === el) { ix = i; break; } }
      if (ix === -1) return;
      var entry = stack.splice(ix, 1)[0];

      entry.el.hidden = true;
      if (entry.tookLock && !stack.some(function (e) { return e.tookLock; })) unlock();
      if (!stack.length) document.removeEventListener('keydown', onKeydown, true);

      // Send focus back where it came from, so keyboard users are not dumped at
      // the top of the document.
      if (entry.returnTo && document.contains(entry.returnTo)) {
        try { entry.returnTo.focus(); } catch (_) {}
      }
      if (entry.onClose) entry.onClose();
    },

    closeAll: function () {
      while (stack.length) CarniModal.close(stack[stack.length - 1].el);
    },

    isOpen: function (el) {
      return stack.some(function (e) { return e.el === el; });
    }
  };

  window.CarniModal = CarniModal;

  // Restoring from the back/forward cache replays the DOM as it was, overlay and
  // scroll lock included. Clear both so the page is not left frozen.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    stack.length = 0;
    document.removeEventListener('keydown', onKeydown, true);
    document.querySelectorAll('[data-carni-share-overlay], [data-carni-notify-overlay]').forEach(function (ov) {
      ov.hidden = true;
    });
    unlock();
  });
})();
